<template>
    <div class="customers-invites-filter">
        <SearchInput
            class="customers-invites-filter__search"
            :placeholder="$t('misc.search')"
            @change="onSearch"
        />
        <CustomSelect
            class="select--filter"
            :model-value="filters.status"
            emit-prop="id"
            placeholder="Status"
            view-label="name"
            :options="statusesArray"
            clearable
            @update:model-value="onChange('status', $event)"
        />
    </div>
</template>

<script>
import { SearchInput, CustomSelect } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'CustomersInvitesFilter',
    components: {
        SearchInput,
        CustomSelect,
    },
    props: {
        filters: {
            type: Object,
            default: () => {},
        },
        statuses: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        statusesArray() {
            return Object.entries(this.statuses).map(([key, label]) => ({ id: key, name: label }));
        },
    },
    methods: {
        onSearch(searchString) {
            this.$emit('search', searchString);
        },
        onChange(field, value) {
            this.$emit('filter', { [field]: value });
        },
    },
};
</script>

<style lang="scss" src="./CustomersInvitesFilter.scss"></style>
